import { render } from "./NewsView.vue?vue&type=template&id=734493bf&scoped=true"
const script = {}

import "./NewsView.vue?vue&type=style&index=0&id=734493bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734493bf"]])

export default __exports__